<mat-card class="feedback">
  <mat-card-header>
    <app-close-btn (btnClick)="dialogRef.close()"></app-close-btn>  </mat-card-header>
  <mat-card-content>
    <div id="ss_survey_widget"></div>
  </mat-card-content>
</mat-card>
